module.exports = __webpack_public_path__ + "static/media/SaubachkomedeLogo2.b5cc59e8.png";